<template>
  <div id="PageHeaderMobile">
    <div class="main-warp">
      <el-page-header @back="goBack" title="" :content="pageHeaderTitle">
      </el-page-header>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageHeaderMobile',
  data() {
    return {
    }
  },
  props: {
    pageHeaderTitle: String
  },
  methods: {
    goBack() {
      this.$emit("goBack")
    }
  }
}
</script>

<style scoped>

</style>
